function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import GalleryView from './galleryView';
import SlideshowView from './slideshowView';
import { addLayoutStyles } from '../helpers/layoutHelper';
import { ItemsHelper } from '../helpers/itemsHelper';
import dimensionsHelper from '../helpers/dimensionsHelper';
import { scrollToItemImp } from '../helpers/scrollHelper';
import window from '../../common/window/windowWrapper';
import ScrollIndicator from './galleryScrollIndicator';
import { Layouter } from 'pro-layouts';
import { cssScrollHelper } from '../helpers/cssScrollHelper.js';
import { createCssLayouts } from '../helpers/cssLayoutsHelper.js';
import utils from '../../common/utils';
import { isEditMode, isSEOMode } from '../../common/window/viewModeWrapper';
import EVENTS from '../../common/constants/events';
import VideoScrollHelper from '../helpers/videoScrollHelper.js';
import { URL_TYPES, URL_SIZES } from '../../common/constants/urlTypes';
import checkNewGalleryProps from './helpers/isNew';
export var GalleryContainer =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(GalleryContainer, _React$Component);

  function GalleryContainer(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    if (utils.isVerbose()) {
      console.count('[OOISSR] galleryContainerNew constructor', window.isMock);
    }

    _this.getMoreItemsIfNeeded = _this.getMoreItemsIfNeeded.bind(_assertThisInitialized(_this));
    _this.enableScrollPreload = _this.enableScrollPreload.bind(_assertThisInitialized(_this));
    _this.toggleLoadMoreItems = _this.toggleLoadMoreItems.bind(_assertThisInitialized(_this));
    _this.scrollToItem = _this.scrollToItem.bind(_assertThisInitialized(_this));
    _this._scrollingElement = _this.getScrollingElement();
    _this.duplicateGalleryItems = _this.duplicateGalleryItems.bind(_assertThisInitialized(_this));
    _this.eventsListener = _this.eventsListener.bind(_assertThisInitialized(_this));
    _this.onGalleryScroll = _this.onGalleryScroll.bind(_assertThisInitialized(_this));
    _this.setPlayingIdxState = _this.setPlayingIdxState.bind(_assertThisInitialized(_this));
    var initialState = {
      pgScroll: 0,
      showMoreClickedAtLeastOnce: false,
      initialGalleryHeight: undefined,
      needToHandleShowMoreClick: false,
      gotFirstScrollEvent: false,
      playingVideoIdx: -1,
      nextVideoIdx: -1,
      viewComponent: null
    };
    _this.state = initialState;
    _this.items = [];
    _this.itemsDimensions = {};
    _this.preloadedItems = {};
    _this.layoutCss = [];
    var videoScrollHelperConfig = {
      setPlayingVideos: isEditMode() ? function () {} : _this.setPlayingIdxState
    };
    _this.videoScrollHelper = new VideoScrollHelper(videoScrollHelperConfig);

    if (utils.isSSR()) {
      _this.initialGalleryState = _this.reCreateGalleryExpensively(props, initialState);

      try {
        _this.galleryInitialStateJson = JSON.stringify(_this.initialGalleryState);
      } catch (e) {
        //todo - report to sentry
        _this.galleryInitialStateJson = null;
      }
    } else {
      try {
        if (!utils.shouldDebug('no_hydrate')) {
          var state = JSON.parse(window.document.querySelector("#pro-gallery-" + props.domId + " #ssr-state-to-hydrate").innerHTML);

          _this.reCreateGalleryFromState({
            items: props.items,
            styles: state.styles,
            container: state.container,
            gotFirstScrollEvent: initialState.gotFirstScrollEvent
          });

          _this.initialGalleryState = state;
        } else {
          _this.initialGalleryState = {}; //this will cause a flicker between ssr and csr
        }
      } catch (e) {
        //hydrate phase did not happen - do it all over again
        _this.initialGalleryState = {};

        try {
          var galleryState = _this.reCreateGalleryExpensively(props);

          if (Object.keys(galleryState).length > 0) {
            _this.initialGalleryState = galleryState;
          }
        } catch (_e) {//
        }
      }
    }

    _this.state = _objectSpread({}, initialState, {}, _this.initialGalleryState);
    return _this;
  }

  var _proto = GalleryContainer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.loadItemsDimensionsIfNeeded();

    var onGalleryCreated = function onGalleryCreated() {
      _this2.getMoreItemsIfNeeded(0);

      _this2.handleNewGalleryStructure();

      _this2.eventsListener(EVENTS.APP_LOADED, {});
    };

    var galleryState = this.reCreateGalleryExpensively(this.props);

    if (Object.keys(galleryState).length > 0) {
      this.setState(galleryState, function () {
        onGalleryCreated();
      });
    } else {
      onGalleryCreated();
    }

    this.videoScrollHelper.initializePlayState();
    this.currentHoverChangeEvent = window.document.createEvent('CustomEvent'); // MUST be 'CustomEvent'

    this.currentHoverChangeEvent.initCustomEvent('current_hover_change', false, false, null);

    if (this.props.galleryId) {
      this.currentHoverChangeEvent.galleryId = this.props.galleryId;
    }
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    if (!this.currentHoverChangeEvent.galleryId && nextProps.galleryId) {
      this.currentHoverChangeEvent.galleryId = nextProps.galleryId;
    }

    var reCreateGallery = function reCreateGallery() {
      var galleryState = _this3.reCreateGalleryExpensively(nextProps);

      if (Object.keys(galleryState).length > 0) {
        _this3.setState(galleryState, function () {
          _this3.handleNewGalleryStructure();
        });
      }
    };

    var getSignificantProps = function getSignificantProps(props) {
      var domId = props.domId,
          styles = props.styles,
          container = props.container,
          items = props.items;
      return {
        domId: domId,
        styles: styles,
        container: container,
        items: items
      };
    };

    if (this.reCreateGalleryTimer) {
      clearTimeout(this.reCreateGalleryTimer);
    }

    var hasPropsChanged = true;

    try {
      var currentSignificatProps = getSignificantProps(this.props);
      var nextSignificatProps = getSignificantProps(nextProps);
      hasPropsChanged = JSON.stringify(currentSignificatProps) !== JSON.stringify(nextSignificatProps);
    } catch (e) {
      console.error('Cannot compare props', e);
    }

    if (hasPropsChanged) {
      if (utils.isVerbose()) {
        console.log('New props arrived', utils.printableObjectsDiff(this.props, nextProps));
      }

      reCreateGallery();

      if (!!nextProps.currentIdx && nextProps.currentIdx > 0) {
        this.scrollToItem(nextProps.currentIdx, false, true, 0);
      }

      if (this.props.isInDisplay !== nextProps.isInDisplay) {
        this.handleNavigation(nextProps.isInDisplay);
      }
    } else {//this is a hack, because in fullwidth, new props arrive without any changes
      // this.reCreateGalleryTimer = setTimeout(reCreateGallery, 1000);
    }
  };

  _proto.loadItemsDimensionsIfNeeded = function loadItemsDimensionsIfNeeded() {
    var _this4 = this;

    if (utils.isSSR()) {
      return;
    }

    if (!(this.galleryStructure && this.galleryStructure.galleryItems && this.galleryStructure.galleryItems.length > 0)) {
      return;
    }

    var galleryItems = this.galleryStructure.galleryItems;
    var itemsWithoutDimensions = galleryItems.filter(function (item) {
      try {
        return item.isVisible && item.isDimensionless && !item.isPreloaded;
      } catch (e) {
        return false;
      }
    });

    if (!itemsWithoutDimensions.length) {
      return;
    }

    var preloadItem = function preloadItem(item, onload) {
      if (!item || !item.itemId || !item.isGalleryItem) {
        return;
      }

      try {
        var id = item.itemId;

        if (_this4.itemsDimensions[id]) {
          return; //already measured
        }

        if (typeof _this4.preloadedItems[id] !== 'undefined') {
          return;
        }

        _this4.preloadedItems[id] = new Image();

        if (utils.isVerbose()) {
          console.log('Preloading item #' + item);
        }

        if (typeof item.preload_url === 'string') {
          _this4.preloadedItems[id].src = item.preload_url;
        } else {
          _this4.preloadedItems[id].src = item.createUrl(URL_SIZES.PRELOAD, URL_TYPES.LOW_RES);
        }

        if (typeof onload === 'function') {
          _this4.preloadedItems[id].onload = function (e) {
            onload(e);
          };
        }

        return _this4.preloadedItems[id];
      } catch (e) {
        console.error('Could not preload item', item, e);
        return;
      }
    };

    var debouncedReCreateGallery = utils.debounce(function () {
      var _this4$props = _this4.props,
          items = _this4$props.items,
          styles = _this4$props.styles,
          container = _this4$props.container,
          watermarkData = _this4$props.watermarkData;
      var params = {
        items: items,
        styles: styles,
        container: container,
        watermarkData: watermarkData,
        itemsDimensions: _this4.itemsDimensions
      };

      var newState = _this4.reCreateGalleryExpensively(params, _this4.state);

      if (Object.keys(newState).length > 0) {
        _this4.setState(newState, function () {
          _this4.handleNewGalleryStructure();
        });
      }
    }, 500);
    itemsWithoutDimensions.forEach(function (item, idx) {
      item.isPreloaded = true;
      preloadItem(item, function (e) {
        try {
          if (utils.isVerbose()) {
            console.log('item loaded event', idx, e);
          }

          var ele = e.srcElement;

          var _item = _this4.items.find(function (itm) {
            return itm.itemId === item.itemId;
          });

          if (_item) {
            var itemDim = {
              width: ele.width,
              height: ele.height,
              measured: true
            };
            Object.assign(_item, itemDim);

            if (typeof _item.metaData === 'object') {
              Object.assign(_item.metaData, itemDim);
            }

            _this4.itemsDimensions[_item.itemId] = itemDim; //rebuild the gallery after every dimension update
            // if (Object.keys(this.itemsDimensions).length > 0) {

            debouncedReCreateGallery(); // }
          }
        } catch (_e) {
          console.error('Could not calc element dimensions', _e);
        }
      });
    });
  };

  _proto.handleNavigation = function handleNavigation(isInDisplay) {
    if (isInDisplay) {
      this.videoScrollHelper.trigger.INIT_SCROLL();
    } else {
      this.videoScrollHelper.stop();
    }
  };

  _proto.handleNewGalleryStructure = function handleNewGalleryStructure() {
    //should be called AFTER new state is set
    var _this$state = this.state,
        container = _this$state.container,
        needToHandleShowMoreClick = _this$state.needToHandleShowMoreClick,
        initialGalleryHeight = _this$state.initialGalleryHeight;
    var styleParams = this.state.styles;
    var numOfItems = this.items.length;
    var layoutHeight = this.layout.height;
    var layoutItems = this.layout.items;
    var isInfinite = this.containerInfiniteGrowthDirection() === 'vertical';
    var updatedHeight = false;
    var needToUpdateHeightNotInfinite = !isInfinite && needToHandleShowMoreClick;

    if (needToUpdateHeightNotInfinite) {
      var showMoreContainerHeight = 138; //according to the scss

      updatedHeight = container.height + (initialGalleryHeight - showMoreContainerHeight);
    }

    var onGalleryChangeData = {
      numOfItems: numOfItems,
      container: container,
      styleParams: styleParams,
      layoutHeight: layoutHeight,
      layoutItems: layoutItems,
      isInfinite: isInfinite,
      updatedHeight: updatedHeight
    };
    this.eventsListener(EVENTS.GALLERY_CHANGE, onGalleryChangeData);

    if (needToHandleShowMoreClick) {
      this.setState({
        needToHandleShowMoreClick: false
      });
    }
  };

  _proto.reCreateGalleryFromState = function reCreateGalleryFromState(_ref) {
    var items = _ref.items,
        styles = _ref.styles,
        container = _ref.container,
        gotFirstScrollEvent = _ref.gotFirstScrollEvent;
    this.isFullWidth = dimensionsHelper.isFullWidth(container); //keep this on top, before the container is recalculated
    //update this.items

    this.items = items.map(function (item) {
      return ItemsHelper.convertDtoToLayoutItem(item);
    });
    var layoutParams = {
      items: this.items,
      container: container,
      styleParams: styles,
      gotScrollEvent: true,
      options: {
        showAllItems: true,
        skipVisibilitiesCalc: true,
        useLayoutStore: false,
        createLayoutOnInit: false
      }
    };
    this.layouter = new Layouter(layoutParams);
    this.layout = this.layouter.createLayout(layoutParams);
    this.galleryStructure = ItemsHelper.convertToGalleryItems(this.layout, {
      sharpParams: styles.sharpParams,
      resizeMediaUrl: this.props.resizeMediaUrl
    });
    this.videoScrollHelper.updateGalleryStructure({
      galleryStructure: this.galleryStructure,
      scrollBase: container.scrollBase,
      videoPlay: styles.videoPlay,
      oneRow: styles.oneRow
    });
    var allowPreloading = isEditMode() || gotFirstScrollEvent;
    this.scrollCss = this.getScrollCssIfNeeded({
      galleryDomId: this.props.domId,
      items: this.galleryStructure.galleryItems,
      styleParams: styles,
      allowPreloading: allowPreloading
    });
    this.createCssLayoutsIfNeeded(layoutParams);
  };

  _proto.createCssLayoutsIfNeeded = function createCssLayoutsIfNeeded(layoutParams, isApproximation) {
    if (isApproximation === void 0) {
      isApproximation = false;
    }

    this.layoutCss = createCssLayouts({
      layoutParams: layoutParams,
      isApproximation: isApproximation,
      isMobile: utils.isMobile(),
      galleryDomId: this.props.domId,
      galleryItems: isApproximation ? null : this.galleryStructure.galleryItems
    });
  };

  _proto.reCreateGalleryExpensively = function reCreateGalleryExpensively(_ref2, curState) {
    var _this5 = this;

    var items = _ref2.items,
        styles = _ref2.styles,
        container = _ref2.container,
        watermarkData = _ref2.watermarkData,
        itemsDimensions = _ref2.itemsDimensions;

    if (utils.isVerbose()) {
      console.count('PROGALLERY [COUNT] reCreateGalleryExpensively');
      console.time('PROGALLERY [TIME] reCreateGalleryExpensively');
    }

    var state = curState || this.state || {};
    this.isFullWidth = dimensionsHelper.isFullWidth(container); //keep this on top, before the container is recalculated

    var _styles, _container;

    var isNew = checkNewGalleryProps({
      items: items,
      styles: styles,
      container: container,
      watermarkData: watermarkData,
      itemsDimensions: itemsDimensions
    }, _objectSpread({}, state, {
      items: this.items
    }));
    var newState = {};

    if (utils.isVerbose()) {
      console.log('PROGALLERY reCreateGalleryExpensively', isNew, {
        items: items,
        styles: styles,
        container: container,
        watermarkData: watermarkData
      });
    }

    if ((isNew.itemsDimensions || isNew.itemsMetadata) && !isNew.items && !isNew.addedItems) {
      //if only the items metadata has changed - use the modified items (probably with the measured width and height)
      this.items = this.items.map(function (item, index) {
        var metaData = Object.assign({}, items[index].metaData);
        return Object.assign(item, {
          metaData: metaData
        }, _objectSpread({}, _this5.itemsDimensions[item.itemId]));
      });
      newState.items = this.items.map(function (item) {
        return item.itemId;
      });
    } else if (isNew.items && !isNew.addedItems) {
      this.items = items.map(function (item) {
        return Object.assign(ItemsHelper.convertDtoToLayoutItem(item), _objectSpread({}, _this5.itemsDimensions[item.itemId]));
      });
      newState.items = this.items.map(function (item) {
        return item.itemId;
      });
      this.gettingMoreItems = false; //probably finished getting more items
    } else if (isNew.addedItems) {
      this.items = this.items.concat(items.slice(this.items.length).map(function (item) {
        return ItemsHelper.convertDtoToLayoutItem(item);
      }));
      newState.items = this.items.map(function (item) {
        return item.itemId;
      });
      this.gettingMoreItems = false; //probably finished getting more items
    }

    if (isNew.styles || isNew.container) {
      styles = styles || state.styles;
      container = container || state.container;
      dimensionsHelper.updateParams({
        styles: styles,
        container: container,
        domId: this.props.domId
      });
      _styles = addLayoutStyles(styles);
      dimensionsHelper.updateParams({
        styles: _styles
      });
      _container = Object.assign({}, container, dimensionsHelper.getGalleryDimensions(container));
      dimensionsHelper.updateParams({
        container: _container
      });
      newState.styles = _styles;
      newState.container = _container;
    } else {
      _styles = state.styles;
      _container = state.container;
    }

    if (!this.galleryStructure || isNew.any) {
      if (utils.isVerbose()) {
        console.count('PROGALLERY [COUNT] - reCreateGalleryExpensively (isNew)');
      }

      var layoutParams = {
        items: this.items,
        container: _container,
        styleParams: _styles,
        gotScrollEvent: true,
        options: {
          showAllItems: true,
          skipVisibilitiesCalc: true,
          useLayoutStore: false
        }
      };

      if (this.layouter && isNew.addedItems) {
        layoutParams.options.useExistingLayout = true;
      } else {
        layoutParams.options.createLayoutOnInit = false;
        this.layouter = new Layouter(layoutParams);
      }

      this.layout = this.layouter.createLayout(layoutParams);
      var itemConfig = {
        watermark: watermarkData,
        sharpParams: _styles.sharpParams,
        lastVisibleItemIdx: this.lastVisibleItemIdx,
        resizeMediaUrl: this.props.resizeMediaUrl
      };
      var existingLayout = this.galleryStructure || this.layout;

      if (isNew.addedItems) {
        this.galleryStructure = ItemsHelper.convertExistingStructureToGalleryItems(existingLayout, this.layout, itemConfig);
      } else {
        this.galleryStructure = ItemsHelper.convertToGalleryItems(this.layout, itemConfig, existingLayout.galleryItems);
      }

      this.videoScrollHelper.updateGalleryStructure({
        galleryStructure: this.galleryStructure,
        scrollBase: _container.scrollBase,
        videoPlay: _styles.videoPlay,
        oneRow: _styles.oneRow,
        cb: this.setPlayingIdxState
      });

      if (isNew.items) {
        this.loadItemsDimensionsIfNeeded();
      }

      var isApproximation = this.isFullWidth && !_styles.oneRow; //FAKE SSR

      this.createCssLayoutsIfNeeded(layoutParams, isApproximation, isNew);
      var allowPreloading = isEditMode() || state.gotFirstScrollEvent || state.showMoreClickedAtLeastOnce;
      this.scrollCss = this.getScrollCssIfNeeded({
        galleryDomId: this.props.domId,
        items: this.galleryStructure.galleryItems,
        styleParams: _styles,
        allowPreloading: allowPreloading
      });
    }

    if (utils.isVerbose()) {
      console.log('PROGALLERY [RENDERS] - reCreateGalleryExpensively', {
        isNew: isNew
      }, {
        items: items,
        styles: styles,
        container: container,
        watermarkData: watermarkData
      });
      console.timeEnd('PROGALLERY [TIME] reCreateGalleryExpensively');
    }

    if (isNew.any) {
      return newState;
    } else {
      return {};
    }
  };

  _proto.getScrollingElement = function getScrollingElement() {
    var _this6 = this;

    var horizontal = function horizontal() {
      return window.document.querySelector("#pro-gallery-" + _this6.props.domId + " #gallery-horizontal-scroll");
    };

    var vertical = this.props.scrollingElement ? typeof this.props.scrollingElement === 'function' ? this.props.scrollingElement : function () {
      return _this6.props.scrollingElement;
    } : function () {
      return window;
    };
    return {
      vertical: vertical,
      horizontal: horizontal
    };
  };

  _proto.scrollToItem = function scrollToItem(itemIdx, fixedScroll, isManual, durationInMS) {
    if (durationInMS === void 0) {
      durationInMS = 0;
    }

    var scrollingElement = this._scrollingElement;
    var horizontalElement = scrollingElement.horizontal();
    return scrollToItemImp({
      isRTL: this.state.styles.isRTL,
      oneRow: this.state.styles.oneRow,
      galleryWidth: this.state.container.galleryWidth,
      galleryHeight: this.state.container.galleryHeight,
      top: 0,
      items: this.galleryStructure.items,
      totalWidth: this.galleryStructure.width,
      itemIdx: itemIdx,
      fixedScroll: fixedScroll,
      isManual: isManual,
      scrollingElement: scrollingElement,
      horizontalElement: horizontalElement,
      durationInMS: durationInMS
    });
  };

  _proto.containerInfiniteGrowthDirection = function containerInfiniteGrowthDirection(styles) {
    if (styles === void 0) {
      styles = false;
    }

    var _styles = styles || this.state.styles; // return the direction in which the gallery can grow on it's own (aka infinite scroll)


    var enableInfiniteScroll = this.props.styles.enableInfiniteScroll;
    var showMoreClickedAtLeastOnce = this.state.showMoreClickedAtLeastOnce;
    var oneRow = _styles.oneRow,
        loadMoreAmount = _styles.loadMoreAmount;

    if (oneRow) {
      return 'horizontal';
    } else if (!enableInfiniteScroll) {
      //vertical gallery with showMore button enabled
      if (showMoreClickedAtLeastOnce && loadMoreAmount === 'all') {
        return 'vertical';
      } else {
        return 'none';
      }
    } else {
      return 'vertical';
    }
  };

  _proto.setPlayingIdxState = function setPlayingIdxState(playingVideoIdx, nextVideoIdx) {
    this.setState({
      playingVideoIdx: playingVideoIdx,
      nextVideoIdx: nextVideoIdx
    });
  };

  _proto.onGalleryScroll = function onGalleryScroll(_ref3) {
    var top = _ref3.top,
        left = _ref3.left;
    this.videoScrollHelper.trigger.SCROLL({
      top: top,
      left: left
    });
  };

  _proto.getScrollCssIfNeeded = function getScrollCssIfNeeded(_ref4) {
    var galleryDomId = _ref4.galleryDomId,
        items = _ref4.items,
        styleParams = _ref4.styleParams,
        allowPreloading = _ref4.allowPreloading;
    var isSEO = isSEOMode();
    var shouldUseScrollCss = !isSEO;

    if (shouldUseScrollCss) {
      return cssScrollHelper.calcScrollCss({
        items: items,
        isFullWidth: this.isFullWidth,
        styleParams: styleParams,
        galleryDomId: galleryDomId,
        allowPreloading: allowPreloading
      });
    } else {
      return '';
    }
  };

  _proto.toggleLoadMoreItems = function toggleLoadMoreItems() {
    var _this7 = this;

    this.eventsListener(EVENTS.LOAD_MORE_CLICKED, this.galleryStructure.galleryItems);
    var showMoreClickedAtLeastOnce = true;
    var needToHandleShowMoreClick = true;

    if (!this.state.gotFirstScrollEvent) {
      //we already called to calcScrollCss with allowPreloading = true
      this.scrollCss = this.getScrollCssIfNeeded({
        galleryDomId: this.props.domId,
        items: this.galleryStructure.galleryItems,
        styleParams: this.state.styles,
        allowPreloading: true
      });
    } //before clicking "load more" at the first time


    if (!this.state.showMoreClickedAtLeastOnce) {
      var initialGalleryHeight = this.state.container.height; //container.height before clicking "load more" at the first time

      this.setState({
        showMoreClickedAtLeastOnce: showMoreClickedAtLeastOnce,
        initialGalleryHeight: initialGalleryHeight,
        needToHandleShowMoreClick: needToHandleShowMoreClick
      }, function () {
        _this7.handleNewGalleryStructure();
      });
    } else {
      //from second click
      this.setState({
        needToHandleShowMoreClick: needToHandleShowMoreClick
      }, function () {
        _this7.handleNewGalleryStructure();
      });
    }
  };

  _proto.enableScrollPreload = function enableScrollPreload() {
    if (!this.state.gotFirstScrollEvent) {
      if (!this.state.showMoreClickedAtLeastOnce) {
        //we already called to calcScrollCss with allowPreloading = true
        this.scrollCss = this.getScrollCssIfNeeded({
          galleryDomId: this.props.domId,
          items: this.galleryStructure.galleryItems,
          styleParams: this.state.styles,
          allowPreloading: true
        });
      }

      this.setState({
        gotFirstScrollEvent: true
      });
    }
  };

  _proto.duplicateGalleryItems = function duplicateGalleryItems() {
    var _this$items,
        _this8 = this;

    var galleryState = this.reCreateGalleryExpensively(_objectSpread({}, this.props, {
      items: (_this$items = this.items).concat.apply(_this$items, this.items.slice(0, this.props.totalItemsCount))
    }));

    if (Object.keys(galleryState).length > 0) {
      this.setState(galleryState, function () {
        _this8.handleNewGalleryStructure();
      });
    }
  };

  _proto.eventsListener = function eventsListener(eventName, eventData) {
    this.videoScrollHelper.handleEvent({
      eventName: eventName,
      eventData: eventData
    });

    if (eventName === EVENTS.HOVER_SET) {
      this.currentHoverChangeEvent.currentHoverIdx = eventData;
      window.dispatchEvent(this.currentHoverChangeEvent);
    }

    if (typeof this.props.eventsListener === 'function') {
      this.props.eventsListener(eventName, eventData);
    }
  };

  _proto.getMoreItemsIfNeeded = function getMoreItemsIfNeeded(scrollPos) {
    var _this9 = this;

    if (this.galleryStructure && this.galleryStructure.galleryItems && this.galleryStructure.galleryItems.length > 0 && !this.gettingMoreItems && this.state.items && this.state.styles && this.state.container) {
      //more items can be fetched from the server
      //TODO - add support for horizontal galleries
      var oneRow = this.state.styles.oneRow;
      var gallerySize = this.galleryStructure[oneRow ? 'width' : 'height'];
      var screenSize = window.screen[oneRow ? 'width' : 'height'];
      var scrollEnd = scrollPos + screenSize + (oneRow ? 0 : this.state.container.scrollBase);
      var getItemsDistance = 3 * screenSize; // console.log('[RTL SCROLL] getMoreItemsIfNeeded: ', scrollPos);

      if (gallerySize - scrollEnd < getItemsDistance) {
        //only when the last item turns visible we should try getting more items
        if (this.state.items.length < this.props.totalItemsCount) {
          this.gettingMoreItems = true;
          this.eventsListener(EVENTS.NEED_MORE_ITEMS, this.state.items.length);
          setTimeout(function () {
            //wait a bit before allowing more items to be fetched - ugly hack before promises still not working
            _this9.gettingMoreItems = false;
          }, 2000);
        } else if (this.state.styles.slideshowLoop) {
          this.duplicateGalleryItems();
        }
      }
    }
  };

  _proto.canRender = function canRender() {
    var can = this.state.container && this.state.styles && this.state.items;

    if (!can && utils.isVerbose()) {
      console.log('PROGALLERY [CAN_RENDER] GalleryContainer', this.state, can, this.state.container, this.state.styles, this.state.items);
    }

    return can;
  };

  _proto.render = function render() {
    if (!this.canRender()) {
      return null;
    }

    var ViewComponent = this.state.styles.oneRow ? SlideshowView : GalleryView;

    if (utils.isVerbose()) {
      console.count('PROGALLERY [COUNTS] - GalleryContainer (render)');
      console.log('PROGALLERY [RENDER] - GalleryContainer', this.state.container.scrollBase, {
        state: this.state,
        items: this.items
      });
    }

    var displayShowMore = this.containerInfiniteGrowthDirection() === 'none';
    var findNeighborItem = this.layouter ? this.layouter.findNeighborItem : function () {};
    var ssrDisableTransition = !!utils.isSSR() && 'div.pro-gallery-parent-container * { transition: none !important }';
    return React.createElement("div", {
      "data-key": "pro-gallery-inner-container",
      key: "pro-gallery-inner-container"
    }, React.createElement(ScrollIndicator, {
      galleryDomId: this.props.domId,
      oneRow: this.state.styles.oneRow,
      isRTL: this.state.styles.isRTL,
      totalWidth: this.galleryStructure.width,
      scrollBase: this.state.container.scrollBase,
      scrollingElement: this._scrollingElement,
      getMoreItemsIfNeeded: this.getMoreItemsIfNeeded,
      enableScrollPreload: this.enableScrollPreload,
      onScroll: this.onGalleryScroll
    }), React.createElement(ViewComponent, _extends({
      galleryDomId: this.props.domId,
      galleryId: this.props.galleryId,
      isInDisplay: this.props.isInDisplay,
      isFullWidth: this.isFullWidth,
      scrollingElement: this._scrollingElement,
      totalItemsCount: this.props.totalItemsCount //the items passed in the props might not be all the items
      ,
      renderedItemsCount: this.props.renderedItemsCount,
      items: this.items,
      itemsLoveData: this.props.itemsLoveData,
      galleryStructure: this.galleryStructure,
      styleParams: this.state.styles,
      container: this.state.container,
      watermark: this.props.watermarkData,
      settings: this.props.settings,
      gotScrollEvent: true,
      scroll: {} //todo: remove after refactor is 100%
      ,
      displayShowMore: displayShowMore,
      domId: this.props.domId,
      customHoverRenderer: this.props.customHoverRenderer,
      customInfoRenderer: this.props.customInfoRenderer,
      playingVideoIdx: this.state.playingVideoIdx,
      nextVideoIdx: this.state.nextVideoIdx,
      noFollowForSEO: this.props.noFollowForSEO,
      actions: _objectSpread({}, this.props.actions, {
        findNeighborItem: findNeighborItem,
        toggleLoadMoreItems: this.toggleLoadMoreItems,
        eventsListener: this.eventsListener,
        setWixHeight: function setWixHeight() {},
        scrollToItem: this.scrollToItem,
        duplicateGalleryItems: this.duplicateGalleryItems
      })
    }, this.props.gallery)), this.galleryInitialStateJson && React.createElement("div", {
      id: "ssr-state-to-hydrate",
      style: {
        display: 'none'
      }
    }, this.galleryInitialStateJson), React.createElement("style", {
      "data-key": "scrollCss",
      key: "scrollCss"
    }, this.scrollCss), this.layoutCss.map(function (css, idx) {
      return React.createElement("style", {
        "data-key": "layoutCss-" + idx,
        key: "layoutCss-" + idx
      }, css);
    }), ssrDisableTransition && React.createElement("style", null, ssrDisableTransition));
  };

  return GalleryContainer;
}(React.Component);
export default GalleryContainer;